import { Image as AntImage } from 'antd';
import PropTypes from 'prop-types';

const Image = ({ alt, src, loadingSrc, onClick, onError, placeholder, className }) => (
  <AntImage
    alt={alt || null}
    className={className || null}
    fallback={loadingSrc || null}
    onClick={onClick || null}
    onError={onError || null}
    placeholder={placeholder || null}
    preview={false}
    src={src || null}
  />
);

Image.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  loadingSrc: PropTypes.string,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  placeholder: PropTypes.node,
  className: PropTypes.string
};

export default Image;
